import { createFileRoute } from '@tanstack/react-router'

import { ActiveCasesEoirPage } from '@/pages/_app/cases-eoir/active/page'
import type { CasesPageSearchParamsValidated } from '@/pages/_app/cases/types'
import type { CasesSortOrder } from '@/pages/_app/types'
import type { CasesSortKey } from '@/pages/_app/types'

import { FilterCondition } from '@/lib/queries/business/v4/case/search/types'

export const Route = createFileRoute('/_app/cases-eoir/active')({
  validateSearch: (search: Record<string, unknown>): CasesPageSearchParamsValidated => {
    return {
      page: Number(search.page) || 1,
      pageSize: search.pageSize ? Number(search.pageSize) : undefined,
      search: search.search as string | undefined,
      sortKey: search.sortKey as CasesSortKey,
      sortOrder: search.sortOrder as CasesSortOrder,
      tags: search.tags as string | string[] | undefined,
      tagCondition:
        search.tagCondition === FilterCondition.and || search.tagCondition === FilterCondition.or
          ? search.tagCondition
          : undefined,
      statuses: search.statuses as string | string[] | undefined,
      assignees: search.assignees as string[] | undefined,
      assigneeCondition:
        search.assigneeCondition === FilterCondition.and || search.assigneeCondition === FilterCondition.or
          ? search.assigneeCondition
          : undefined,
    }
  },
  component: ActiveCasesEoirPage,
})
